import { HttpClient } from '@sphere/shared/data-access/http'
import type { IOffsetPaginationResponse } from '@sphere/shared/domain'
import type {
  Attempt,
  CanStartAttempt,
  AttemptStatistics,
  GradeAttemptRequestDto,
  ListAttemptsRequestDto,
  StartAttemptRequestDto,
  SubmitAttemptRequestDto,
  UpdateAttemptRequestDto,
  UpdateGradingRequestDto,
} from '@sphere/learning/domain'

export const attemptsClient = {
  list: (params: ListAttemptsRequestDto) =>
    HttpClient.get<IOffsetPaginationResponse<Attempt>>('/learning/attempts', {
      params,
    }),

  getById: (id: string) => HttpClient.get<Attempt>(`/learning/attempts/${id}`),

  getResult: (id: string) =>
    HttpClient.get<Attempt>(`/learning/attempts/${id}/result`),

  start: (activityId: string, data: StartAttemptRequestDto) =>
    HttpClient.post<Attempt>(
      `/learning/activities/${activityId}/attempts/start`,
      data
    ),

  submit: (attemptId: string, data?: SubmitAttemptRequestDto) =>
    HttpClient.post<Attempt>(
      `/learning/attempts/${attemptId}/submit`,
      data ?? {}
    ),

  grade: (attemptId: string, data: GradeAttemptRequestDto) =>
    HttpClient.post<Attempt>(`/learning/attempts/${attemptId}/grade`, data),

  updateGrading: (attemptId: string, data: UpdateGradingRequestDto) =>
    HttpClient.patch<Attempt>(`/learning/attempts/${attemptId}/grading`, data),

  update: (attemptId: string, data: UpdateAttemptRequestDto) =>
    HttpClient.patch<Attempt>(`/learning/attempts/${attemptId}`, data),

  delete: (attemptId: string) =>
    HttpClient.delete<void>(`/learning/attempts/${attemptId}`),

  listByActivity: (
    activityId: string,
    params: Omit<ListAttemptsRequestDto, 'activityId'> = {}
  ) =>
    HttpClient.get<IOffsetPaginationResponse<Attempt>>(
      `/learning/activities/${activityId}/attempts`,
      { params }
    ),

  getMyStatistics: () =>
    HttpClient.get<AttemptStatistics>('/learning/attempts/my-statistics'),
  canStart: (activityId: string) =>
    HttpClient.get<CanStartAttempt>(
      `/learning/activities/${activityId}/attempts/can-start`
    ),
}
